import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Booking from "@/pages/Booking";
import ConfirmBooking from "@/pages/ConfirmBooking";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";
import SocialButtons from "@/components/SocialButtons";

function App() {
  return (
    <div className="App min-h-screen">
      <div className="grain-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Booking />} />
          <Route path="/confirmar" element={<ConfirmBooking />} />
          <Route path="/confirm" element={<ConfirmBooking />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <SocialButtons />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
